<span class="w-fit rounded-full px-2 py-0.5 text-xs" [ngStyle]="{ 'background-color': backgroundColor, 'color': foregroundColor }">
    {{value}}
    </span>